"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUseStyles = createUseStyles;
exports.default = void 0;
exports.getStyleOverrides = getStyleOverrides;
exports.getThemeOverrides = getThemeOverrides;
exports.mergeComponentOverrides = mergeComponentOverrides;
var _reactJss = require("react-jss");
var _mergeProps = _interopRequireDefault(require("../utils/mergeProps"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

/**
 * Attach CSS styles to a React component
 * @param styles - The styles object or function
 * @param options - The name of the component
 * @returns an object of CSS class names
 */
function createUseStyles(styles, options) {
  // Convert styles object into a function for easier handling
  var getStyles = typeof styles === "function" ? styles : function () {
    return styles;
  };
  // This function gets called on initial render and when the theme changes
  var withGlobalComponentOverrides = function withGlobalComponentOverrides(theme) {
    return mergeComponentOverrides(getStyles, theme, options.name);
  };
  return (0, _reactJss.createUseStyles)(withGlobalComponentOverrides, options);
}

/**
 * Merge component style & theme overrides (if they exist) into the styles object
 * @param getStyles - The styles function
 * @param theme - The ITheme object
 * @param componentName - The name of the component
 * @returns a style object with component style & theme overrides applied (if they exist)
 */
function mergeComponentOverrides(getStyles, theme, componentName) {
  var _theme$components;
  // Fast path - no theme or style overrides set
  if (!((_theme$components = theme.components) !== null && _theme$components !== void 0 && _theme$components[componentName])) {
    return getStyles(theme);
  }
  // Create a copy of the theme with component theme overrides applied (if they exist)
  var updatedTheme = (0, _mergeProps.default)(theme, getThemeOverrides(theme, componentName));
  // Unwrap the styles object from the styles function and apply the component style overrides (if they exist)
  return (0, _mergeProps.default)(getStyles(updatedTheme), getStyleOverrides(updatedTheme, componentName));
}

/**
 * Get the component theme overrides (if they exist)
 * @param theme - The ITheme object
 * @param componentName - The name of the component
 * @returns the component theme overrides (if they exist)
 */
function getThemeOverrides(theme, componentName) {
  var _theme$components2;
  var overrides = (_theme$components2 = theme.components) === null || _theme$components2 === void 0 || (_theme$components2 = _theme$components2[componentName]) === null || _theme$components2 === void 0 ? void 0 : _theme$components2.theme;
  return typeof overrides === "function" ? overrides(theme) : overrides;
}

/**
 * Get the component style overrides (if they exist)
 * @param theme - The ITheme object
 * @param componentName - The name of the component
 * @returns the component style overrides (if they exist)
 */
function getStyleOverrides(theme, componentName) {
  var _theme$components3;
  var overrides = (_theme$components3 = theme.components) === null || _theme$components3 === void 0 || (_theme$components3 = _theme$components3[componentName]) === null || _theme$components3 === void 0 ? void 0 : _theme$components3.styles;
  return typeof overrides === "function" ? overrides(theme) : overrides;
}
var _default = exports.default = createUseStyles;